import { SortParams } from '@epicuro-next/data/baskets';
import { isNonNullish } from '@epicuro-next/utilities';
import {
  Basket,
  BasketGroupSortType,
  BasketRow,
  BasketRowsGroup,
  SortDirection,
} from 'graphql-api/baskets-api-interfaces';

import {
  alphabeticalFunction,
  compareByTotalWsp,
  comparers,
  groupComparers,
} from './mappings';

export function sortGroupedBasket(
  basket: Basket,
  sortType: BasketGroupSortType,
  sortDirection: SortDirection,
): Basket {
  const sortParams = { type: sortType, direction: sortDirection };

  return {
    ...basket,
    groups: sortNestedGroups(sortParams, basket.groups),
  };
}

function sortNestedGroups(
  sortParams: SortParams,
  groups: BasketRowsGroup[],
): BasketRowsGroup[] {
  const groupCompareFn =
    groupComparers[sortParams.type] ?? alphabeticalFunction;

  return [...groups]
    .sort((a, b) => groupCompareFn(a, b, sortParams.direction))
    .map((group) => {
      const nestedGroups = group?.groups?.filter(isNonNullish) || [];
      const hasNestedGroups = nestedGroups?.length;

      return {
        ...group,
        ...(hasNestedGroups
          ? { groups: sortNestedGroups(sortParams, nestedGroups) }
          : { rows: sortRows(sortParams, group.rows) }),
      };
    });
}

function sortRows(sortParams: SortParams, rows?: BasketRow[] | null) {
  const compareFn = comparers[sortParams.type] ?? compareByTotalWsp;

  return rows
    ?.filter(isNonNullish)
    .sort((a, b) => compareFn(a, b, sortParams.direction));
}
